import { BioCodeCreationParams, BioCodeData } from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/bio-code';

export class BioCodeApi {
    public static async getList(): Promise<BioCodeData[]> {
        const res = await axios.get(BASE_URL);

        return res.data.bioCodes;
    }

    public static async create(params: BioCodeCreationParams): Promise<void> {
        await axios.post(BASE_URL, params);
    }
}

export { BASE_URL as BIO_CODE_BASE_URL };
